import { render, staticRenderFns } from "./sanTicketPrint.vue?vue&type=template&id=bc2e2cf2&scoped=true&"
import script from "./sanTicketPrint.vue?vue&type=script&lang=js&"
export * from "./sanTicketPrint.vue?vue&type=script&lang=js&"
import style0 from "./sanTicketPrint.vue?vue&type=style&index=0&id=bc2e2cf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2e2cf2",
  null
  
)

component.options.__file = "sanTicketPrint.vue"
export default component.exports